export default {"src":"/_next/static/media/brilliant.5eb8f71c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};